import { useEffect, useState, useContext } from "react";
import { Stack, Typography, GTIWebTextField, GTIWebNumberField, GTIWebAlert, Link } from "@gti-controls-v2/web-core";
import { SettingsContext } from "../../../../providers/settings";
import ModalTicket from "../../../../components/modal-ticket";
import { isNumberValid, isPhoneValid, isEmailValid } from "../../../../common/utilities/validations";
import { verifySendCodeDateTime, deleteSendCodeDateTimeItem } from "../../../../common/utilities/verifyCode";
import useUsers from "../../../../hooks/useUsers";
import homePageStyles from "../../../../common/styles/HomePage";

const ModalEditData = ({ username, phone, email, open, onClose, onDataUpdate, ticketID }) => {
    const styles = homePageStyles;
    const [currentStep, setCurrentStep] = useState(0);
    const [currentPhone, setCurrentPhone] = useState(phone);
    const [currentEmail, setCurrentEmal] = useState(email);
    const [closeModal, setCloseModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [errorModal, setErrorModal] = useState(null);
    const [disabledBtnNext, setDisabledBtnNext] = useState(true);
    const { isLoading, handleLoading } = useContext(SettingsContext);
    const { existPhone, existEmail, sendRecoveryCode, verifyRecoveryCode, saveDataAccount } = useUsers();
    const secondsWaiting = 120;
    const [time, setTime] = useState("");
    const [sendCodePhone, setSendCodePhone] = useState(true);
    const [sendCodeEmail, setSendCodeEmail] = useState(true);
    const [data, setData] = useState({
        correo: "",
        celular: "",
        codePhone: "",
        codeEmail: "",
        savePhone: false,
        saveEmail: false,
    });
    const instructions = "Enviamos el código de confirmación al"

    const options = {
        correo: 0,
        celular: 1
    }

    const form = {
        celular: {
            id: 2,
            title: "Celular",
            name: "celular"
        },
        correo: {
            id: 1,
            title: "Correo",
            name: "correo"
        },
        codePhone: {
            id: 3,
            title: "Introduce el código",
            name: "codePhone"
        },
        codeEmail: {
            id: 4,
            title: "Introduce el código",
            name: "codeEmail"
        },
        btnSubmit: {
            title: "Siguiente"
        }
    };

    const steps = [
        {
            title: "Modificar información personal",
            description: "Se deberá capturar al menos uno de los dos datos personales (celular o correo) para poder continuar. Solo se enviará el código de seguridad al dato que haya sido capturado."
        },
        {
            title: "Verificar celular",
            description: `${instructions} celular:`
        },
        {
            title: "Verificar correo",
            description: `${instructions} correo:`
        }
    ];

    const validationErrors = {
        Phone: {
            dato: 'Este número ya está en uso. Ingresa uno distinto o revisa que esté bien escrito.',
            state: 'error'
        },
        Email: {
            dato: 'Este correo ya está registrado. Verifica que sea correcto o utiliza uno diferente.',
            state: 'error'
        },
        Code: {
            code: 'Código inválido',
            state: 'regexError'
        }
    };

    useEffect(() => {
        setCurrentStep(0);
        setCloseModal(false);
        setErrors({});
        setErrorModal(null);
        setCurrentEmal(email);
        setCurrentPhone(phone);
        setData((prev) => ({
            ...prev,
            correo: email,
            celular: phone,
            codePhone: "",
            codeEmail: ""
        }));
    }, [open, phone, email])

    useEffect(() => {
        if (data.correo !== currentEmail || data.celular !== currentPhone) {
            setDisabledBtnNext(false);
        } else {
            setDisabledBtnNext(true);
            setErrorModal(null);
        }
        // eslint-disable-next-line
    }, [data])

    useEffect(() => {
        if (currentStep === 1) {
            updateCounter(data.celular, time === '01:59' ? false : sendCodePhone, setSendCodePhone);
        } else if (currentStep === 2) {
            updateCounter(data.correo, time === '01:59' ? false : sendCodeEmail, setSendCodeEmail);
        }

        // eslint-disable-next-line
    }, [currentStep, time, sendCodePhone, sendCodeEmail])

    useEffect(() => {
        if (closeModal) {
            handleCloseModal();
        }
        // eslint-disable-next-line
    }, [closeModal])

    const validate = () => {
        const newErrors = {};

        if (currentStep === 0) {
            if (data.celular.length > 0) {
                if (isNumberValid(data.celular)) {
                    if (!isPhoneValid(data.celular)) {
                        newErrors.celular = {
                            state: "error",
                            msg: data.celular.length < 10
                                ? "Teléfono celular incompleto."
                                : "Teléfono celular incorrecto."
                        };
                    }
                } else {
                    newErrors.celular = {
                        state: "error",
                        msg: 'Teléfono celular incorrecto.'
                    };
                }
            } else if (currentPhone.length > 0) {
                newErrors.celular = {
                    state: "error",
                    msg: 'El teléfono es requerido.'
                };
            }

            if (data.correo.length > 0) {
                if (!isEmailValid(data.correo)) {
                    newErrors.correo = {
                        state: "error",
                        msg: "Correo electrónico incompleto. Ejemplo: ejemplo@correo.com"
                    };
                }
            } else if (currentEmail.length > 0) {
                newErrors.correo = {
                    state: "error",
                    msg: "El correo electrónico es requerido."
                };
            }
        } else {
            const codeValue = currentStep === 1 ? data.codePhone : data.codeEmail
            let errorState = null;
            let errorMsg = null
            if (codeValue.length === 0) {
                errorState = 'regexError'
                errorMsg = "El Código de Verificación es requerido.";
            }
            if (codeValue.length > 0 && codeValue.length !== 4) {
                errorState = 'regexError'
                errorMsg = "El Código de Verificación es de 4 digitos.";
            }

            if (errorState && errorMsg) {

                if (currentStep === 1) {
                    newErrors.codePhone = {
                        state: errorState,
                        msg: errorMsg
                    };
                } else {
                    newErrors.codeEmail = {
                        state: errorState,
                        msg: errorMsg
                    };
                }
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const updateCounter = (value, send, setResend) => {
        const timer = setTimeout(async () => {
            if (!send) {
                let resp = verifySendCodeDateTime(new Date().getTime(), value, secondsWaiting, false)
                setResend(resp.valid)
                setTime(resp.timer)
            }
        }, secondsWaiting * 10);
        
        return () => clearInterval(timer)
    };

    const handlerOnChange = (e) => {
        const { name, value } = e.target;

        setErrors((prev) => ({
            ...prev,
            [name]: {},
        }));
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const sendConde = async (value, option) => {
        let resp = verifySendCodeDateTime(new Date().getTime(), value, secondsWaiting, false)
        if (resp.valid) {
            const resultSendCode = await sendRecoveryCode(username, option, option === options.celular ? value : null, option === options.correo ? value : null)
            if (resultSendCode?.okMessage) {
                updateCounter(value, false, option === options.celular ? setSendCodePhone : setSendCodeEmail);
                return true
            }
            setErrorModal({ message: "Ocurrió un problema al enviar el código de verificación" });
            return false;
        }
        updateCounter(value, false, option === options.celular ? setSendCodePhone : setSendCodeEmail);
        
        return true;
    };

    const verifyCode = async (code, option) => {
        const responseVeriCode = await verifyRecoveryCode(username, option, code, null);
        if (responseVeriCode?.error) {
            setErrorModal({ message: responseVeriCode.error });
        }
        if (responseVeriCode?.okMessage) {
            const saveData = await saveDataAccount(username, option === options.celular ? data.celular : null, option === options.correo ? data.correo : null, null, null, ticketID);
            if (!saveData?.exitoso) {
                setErrorModal({ message: saveData?.error ?? "Ocurrió un error al guardar nuevo dato." });
            } else {
                deleteSendCodeDateTimeItem(option === options.celular ? data.celular : data.correo);
                let name = option === options.celular ? 'savePhone' : 'saveEmail';
                setData((prev) => ({
                    ...prev,
                    [name]: true,
                }));

                return true;
            }
        }

        return false;
    };

    const handleSubmit = async () => {
        setErrorModal(null);
        handleLoading(true);
        
        if (validate()) {
            if (currentStep === 0) {
                await handleSubmitData();
            } else if (currentStep === 1) {
                await handleConfirmPhone();
            } else if (currentStep === 2) {
                await handleConfirmEmail();
            }
        }

        handleLoading(false);
    };

    const handleSubmitData = async () => {
        const celularExists = data.celular !== currentPhone ? await existPhone(data.celular) : { exists: false };
        const correoExists = data.correo !== currentEmail ? await existEmail(data.correo) : { exists: false };

        if (celularExists.exists || correoExists.exists) {
            setErrorModal({ message: <ErrorMessage errorCelular={celularExists.exists ? validationErrors.Phone.dato : null} errorCorreo={correoExists.exists ? validationErrors.Email.dato : null} /> });
            return
        }

        if (data.celular !== currentPhone) {
            const resultSendCode = await sendConde(data.celular, options.celular);
            if (resultSendCode) {
                setCurrentStep(currentStep + 1)
            }
        } else if (data.correo !== currentEmail) {
            const resultSendCode = await sendConde(data.correo, options.correo);
            if (resultSendCode) {
                setCurrentStep(currentStep + 2)
            }
        }
    };

    const handleConfirmPhone = async () => {
        const valid = await verifyCode(data.codePhone, options.celular);

        if (valid) {
            setCurrentPhone(data.celular);
            if (data.correo !== currentEmail) {
                const resultSendCode = await sendConde(data.correo, options.correo);
                if (resultSendCode) {
                    setCurrentStep(currentStep + 1)
                }
            } else {
                setCloseModal(true);
            }
        }
    };

    const handleConfirmEmail = async () => {
        const valid = await verifyCode(data.codeEmail, options.correo);
        if (valid) {
            setCurrentEmal(data.correo);
            setCloseModal(true);
        }
    };

    const handleBack = async () => {
        if (data.celular !== currentPhone) {
            setCurrentStep(currentStep - 1)
        } else if (data.correo !== currentEmail) {
            setCurrentStep(currentStep - 2)
        }
    };

    const ErrorMessage = ({ errorCelular, errorCorreo }) => {
        return (
            <ul>
                {errorCelular ? <li>{errorCelular}</li> : null}
                {errorCorreo ? <li>{errorCorreo}</li> : null}
            </ul>
        );
    };

    const handleCloseModal = async () => {
        if (data.savePhone) {
            deleteSendCodeDateTimeItem(data.celular)
            updateValues(options.celular)
        }

        if (data.saveEmail) {
            deleteSendCodeDateTimeItem(data.correo)
            updateValues(options.correo)
        }

        await onClose();
    };

    const updateValues = (option) => {
        if (onDataUpdate) {
            onDataUpdate({
                type: option === options.celular ? 'phone' : 'email',
                value: option === options.celular ? data.celular : data.correo
            });
        }
    };

    return (
        <ModalTicket type={'step'} open={open} onClose={handleCloseModal} onSubmit={handleSubmit} title={steps[currentStep].title} isLoading={isLoading} disabledSubmitButton={disabledBtnNext} currentStep={currentStep} onBack={handleBack} error={errorModal} >

            {
                currentStep === 0 ?
                    <Stack spacing={2}>
                        <GTIWebAlert
                            severity="info"
                            text={steps[0].description}
                        />
                        <GTIWebTextField
                            name={form.celular.name}
                            labelText={form.celular.title}
                            width="100%"
                            autoFocus={true}
                            autoComplete={"off"}
                            value={data.celular ?? ""}
                            onBlur={handlerOnChange}
                            onChange={handlerOnChange}
                            state={errors.celular?.state}
                            legendText={errors.celular?.msg}
                            length={10}
                        />

                        <GTIWebTextField
                            name={form.correo.name}
                            labelText={form.correo.title}
                            width="100%"
                            autoFocus={true}
                            autoComplete={"off"}
                            value={data.correo ?? ""}
                            onBlur={handlerOnChange}
                            onChange={handlerOnChange}
                            state={errors.correo?.state}
                            legendText={errors.correo?.msg}
                        />
                    </Stack>
                    : <Stack spacing={2}>
                        <Typography>{steps[currentStep].description}</Typography>
                        <Typography sx={styles.modalEditDataValue}>
                            {currentStep === 1 ? data.celular : data.correo}
                        </Typography>
                        <Typography>
                            <span style={styles.modalEditDataValue} >{time}</span><br />
                            <span>Si el código no llega en 2 minutos intenta:</span><br />
                            <Link component="button" variant="body2" onClick={async () => { handleLoading(true); await sendConde(currentStep === 1 ? data.celular : data.correo, currentStep === 1 ? options.celular : options.correo); handleLoading(false); }} disabled={currentStep === 1 ? !sendCodePhone : !sendCodeEmail} >
                                Enviar código nuevamente
                            </Link>
                        </Typography>

                        <GTIWebNumberField
                            domain="code"
                            name={currentStep === 1 ? form.codePhone.name : form.codeEmail.name}
                            labelText={currentStep === 1 ? form.codePhone.title : form.codeEmail.title}
                            width="200px"
                            onBlur={handlerOnChange}
                            onChange={handlerOnChange}
                            length={4}
                            min={0}
                            max={9999}
                            allowLeadingZeros
                            value={currentStep === 1 ? data.codePhone : data.codeEmail}
                            error={currentStep === 1 ? errors.codePhone?.state : errors.codeEmail?.state}
                            regexError={currentStep === 1 ? errors.codePhone?.msg : errors.codeEmail?.msg}
                        />

                    </Stack>
            }
        </ModalTicket>
    )
};

export default ModalEditData;